import { render, staticRenderFns } from "./ModalLicenseManage.vue?vue&type=template&id=27f65274&scoped=true&"
import script from "./ModalLicenseManage.vue?vue&type=script&lang=js&"
export * from "./ModalLicenseManage.vue?vue&type=script&lang=js&"
import style0 from "./ModalLicenseManage.vue?vue&type=style&index=0&id=27f65274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f65274",
  null
  
)

export default component.exports